var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-scroll-option-item",class:{
        'pl-scroll-option-item-disabled':_vm.disabled,
        'pl-scroll-option-item-active':_vm.currentIndex === _vm.index
     },style:(_vm.styles),on:{"click":function($event){$event.stopPropagation();!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }